export default __webpack_public_path__ + "assets/models/b8a42aebb3c38c5894da00f1eda172b5.glb";